const projectData = [
  {
    title: "Apnagram",
    date: "2022 January",
    description:
      "Apnagram is a social media web application quite similar to Instagram, built using MERN stack. It has features such as register/login, create or delete posts, follow/unfollow users, like or unlike posts and much more.",
    link: "https://apnagram.netlify.app/",
    icon: "Public", 
    position: "left",
  },
  {
    title: "E-shop API",
    date: "2021 June",
    description:
      "It is an e-commerce API built using Node.js. Different roles can be managed in this (i.e. Admin or Non-Admin). Admin has permission to add or delete products and their categories, count users, and much more. Non-admin can register/login and make orders. The user is authenticated and provided with a JWT token to access protected routes.",
    link: "https://github.com/Vaibhav-afk/e-Shop",
    icon: "GitHubIcon", 
    position: "right",
  },
  {
    title: "Covid Tracker",
    date: "2020 October",
    description:
      "An android app built with Java which shows covid data such as Indian cases, foreign cases, discharged patients and deaths based on the state entered by the user.",
    link: "https://github.com/Vaibhav-afk/Covid-Tracker",
    icon: "GitHubIcon", 
    position: "left",
  },
  {
    title: "Keeper Web App",
    date: "2020 November",
    description:
      "Keeper is basically a note-taking web application built using React and Firebase inspired from Google Keep.",
    link: "https://my-keeper-web-app.netlify.app/",
    icon: "Public", 
    position: "right",
  },
  {
    title: "Blog Website",
    date: "2020 October",
    description:
      "It is a Blog website, created using EJS & MongoDB. The blog post we create get saved in the database.",
    link: "https://github.com/Vaibhav-afk/A-Blog-Website",
    icon: "GitHubIcon", 
    position: "left",
  },
  {
    title: "Tindog Website",
    date: "2020 September",
    description: "Webpage created using just HTML and CSS.",
    link: "https://vaibhav-afk.github.io/Tindog/",
    icon: "Public", 
    position: "right",
  },
];

export default projectData;
